import {Component} from "@angular/core";
import {BusinessService} from "../../../services/data/business.service";
import {ActivatedRoute} from "@angular/router";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";
import {AuthentService} from "../../../services/authent.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'activation',
  template: require('./activation.component.html'),
  styles: [
    require('./activation.component.scss')
  ]
})

export class ActivationComponent {

  activated: boolean = false;
  activating: boolean = true;

  private paramSubscription: Subscription = null;

  ngOnDestroy(): void {
    this.paramSubscription.unsubscribe();
  }

  constructor(private businessService: BusinessService, private activatedRoute: ActivatedRoute,
              private authent: AuthentService, private currentBusinessService: CurrentBusinessService) {
    this.paramSubscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        let code = param['code'];
        let id = param['id'];

        this.activateBusiness(code, id);
      });

  }

  activateBusiness(code: string, businessId: number) {
    this.businessService.activateBusiness(code, businessId).subscribe(
      response => {
        this.activating = false;
        this.activated = true;
        if (this.authent.isLogged()) {
          this.currentBusinessService.reloadBusiness();
        }
      },
      error => {
        this.activating = false;
        this.activated = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/business/activation/activation.component.ts